import React from 'react';
import { ModuleBase, Stack, Text } from '@/components';
import { SideBySideModuleModel } from './SideBySideModule';

const AdvisoryOurExperts = (data: SideBySideModuleModel) => {
  const {
    props: { title, description },
  } = data;

  return (
    <ModuleBase data={data} noPadding className="AdvisoryOurExperts overflow-hidden pt-10 lg:pt-18">
      <Stack className="container flex flex-col justify-between">
        <div className="flex flex-col gap-6 lg:flex-row lg:gap-2">
          {title && <Text className="text-style-h3 lg:w-1/2" dangerouslySetInnerHTML={{ __html: title }} />}
          <Text className="text-style-h5 lg:w-1/2" dangerouslySetInnerHTML={{ __html: description || '' }} />
        </div>
      </Stack>
    </ModuleBase>
  );
};

export default AdvisoryOurExperts;
